import { fetchWithTimeout } from "@/utils";
import { HttpCode, HttpStatus, bffTimeout } from "@/constants";
/**
 * Returns an async function that calls the BFF with a Timeout
 *
 * In case of error, we always return the Classified object even if incomplete (to help debug)
 * or if the bffResponse status is 4XX (to display similarListings, if any)
 *
 * @returns classified - a Classified object or null
 * @returns error - an Error object or null
 */
export const getFetcher = (bffUrl, locale) => async () => {
    let error = null;
    let classified = null;
    if (!bffUrl) {
        error = { code: HttpCode.NOT_FOUND, status: HttpStatus.BROKEN_LINK };
    }
    let bffRes;
    if (!error) {
        const headers = {
            "accept-language": locale,
        };
        try {
            bffRes = await fetchWithTimeout(bffUrl, {
                headers,
            }, bffTimeout);
        }
        catch (e) {
            console.log(e);
            // We avoid 5XX as CloudFront returns the domain-level error page
            error = { code: HttpCode.BAD_REQUEST, status: HttpStatus.TIMEOUT };
        }
    }
    if (!error && (bffRes === null || bffRes === void 0 ? void 0 : bffRes.error) === HttpStatus.TIMEOUT) {
        error = { code: HttpCode.NOT_FOUND, status: HttpStatus.TIMEOUT };
    }
    if (!error) {
        try {
            classified = await bffRes.json();
        }
        catch (e) {
            error = { code: HttpCode.NOT_FOUND, status: HttpStatus.TIMEOUT };
        }
    }
    if (!error) {
        if ((bffRes === null || bffRes === void 0 ? void 0 : bffRes.status) === HttpCode.GONE) {
            error = { code: HttpCode.GONE, status: HttpStatus.DELETED };
        }
        else if ((bffRes === null || bffRes === void 0 ? void 0 : bffRes.status) === HttpCode.NOT_FOUND) {
            error = { code: HttpCode.NOT_FOUND, status: HttpStatus.UNPUBLISHED };
        }
        else if (!(bffRes === null || bffRes === void 0 ? void 0 : bffRes.ok)) {
            error = {
                code: HttpCode.NOT_FOUND,
                status: HttpStatus.TECHNICAL_ERROR,
            };
        }
    }
    // This cases shouldn't happen, but we handle them just in case 🤞
    if (!error && !(classified === null || classified === void 0 ? void 0 : classified.id)) {
        error = {
            code: HttpCode.NOT_FOUND,
            status: HttpStatus.TECHNICAL_ERROR,
        };
    }
    if (!error && !(classified === null || classified === void 0 ? void 0 : classified.contactSections)) {
        error = {
            code: HttpCode.NOT_FOUND,
            status: HttpStatus.TECHNICAL_ERROR,
        };
    }
    return { classified, error };
};
